import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import {
  AnchorEPIMSActions,
  AnchorEPIMSStoreSelectors,
  AnchorEPIMSSStoreReducer,
} from "./index";
import { CountryDto } from "@cradua/data";

@Injectable()
export class AnchorEPIMSFacade {
  constructor(
    private store: Store<AnchorEPIMSSStoreReducer.EPIMSGatePartialState>,
  ) {}

  anchorEPIMSRecord$ = this.store.select(AnchorEPIMSStoreSelectors.getSelected);

  getselected() {
    return this.store.select(AnchorEPIMSStoreSelectors.getSelected);
  }

  isLoadingEPIMSGate(modeltype: string) {
    // let invokeAction = AnchorEPIMSActions.loadEpimsgate("Club");
    //let newInvoke = invokeAction('Club');

    this.store.dispatch(
      AnchorEPIMSActions.loadEpimsgate(modeltype)({ modeltype }),
    );

    return this.store.select(AnchorEPIMSStoreSelectors.loadingEPIMS);
  }

  loadEPIMSGate(modeltype: string) {
    //let invokeAction = AnchorEPIMSActions.loadEpimsgate("Club");
    // console.log("Reaching Load Facade ", AnchorEPIMSActions.loadEpimsgate("Club"));

    console.log("Type Passed in LoadEPIMSGate ", modeltype);

    this.store.dispatch(
      AnchorEPIMSActions.loadEpimsgate(modeltype)({ modeltype }),
    );
    // this.store.select(AnchorEPIMSStoreSelectors.getAllEPIMS(modeltype)).subscribe((data) => {
    // 	console.log("Data from the Store Up ", data );
    // 	});
    return this.store.select(AnchorEPIMSStoreSelectors.getAllEPIMS(modeltype));
  }

  // isLoadingByTypeStakeholderReference(type: string, countryId: string, stakeholdergroupId: string) {
  // 	this.store.dispatch(StakeholderReferenceStoreActions.loadByTypeStakeholderReference({reftype: type, countryId, stakeholdergroupId}));
  // 	return this.store.select(StakeholderReferenceStoreSelectors.loadingByTypeStakeholderReference);
  // }

  // loadByTypeStakeholderReference(type: string, countryId: string, stakeholdergroupId: string) {
  // 	this.store.dispatch(StakeholderReferenceStoreActions.loadByTypeStakeholderReference({reftype: type, countryId, stakeholdergroupId}));
  // 	return this.store.select(StakeholderReferenceStoreSelectors.getAllByTypeStakeholderReference);
  // }

  // isLoadingByTypeStakeholderReferenceGroup(type: string, countryId: string, stakeholdergroupId: string) {
  // 	this.store.dispatch(StakeholderReferenceStoreActions.loadByTypeStakeholderReferenceGroup({reftype: type, countryId, stakeholdergroupId}));
  // 	return this.groupstore.select(StakeholderReferenceGroupStoreSelectors.loadingByTypeStakeholderReferenceGroup);
  // }

  // loadByTypeStakeholderReferenceGroup(type: string, countryId: string, stakeholdergroupId: string) {
  // 	this.store.dispatch(StakeholderReferenceStoreActions.loadByTypeStakeholderReferenceGroup({reftype: type, countryId, stakeholdergroupId}));
  // 	return this.groupstore.select(StakeholderReferenceGroupStoreSelectors.getAllByTypeStakeholderReferenceGroup);
  // }

  add(modelType: string, dataToAdd: any[]) {
    this.store.dispatch(
      AnchorEPIMSActions.addViaEpimsgate(modelType)({ dataToAdd, modelType }),
    );
  }

  update(modelType: string, dataToAdd: any[], deletedData: any[]) {
    console.log("Reaching Update Facade ", dataToAdd);
    this.store.dispatch(
      AnchorEPIMSActions.updateViaEpimsgate(modelType)({
        dataToAdd,
        deletedData,
        modelType,
      }),
    );
  }

  remove(modelType: string, ids: string[], reftype: string) {
    this.store.dispatch(
      AnchorEPIMSActions.removeViaEpimsgate(modelType)({ ids, modelType }),
    );
  }

  uploadDocumentWithFile(type: string, file: File, document: any[]) {
    this.store.dispatch(
      AnchorEPIMSActions.documentUploadRequest({ file, document }),
    );
  }

  completd() {
    return this.store.select(
      AnchorEPIMSStoreSelectors.selectUploadFileCompleted,
    );
  }
  progress() {
    return this.store.select(
      AnchorEPIMSStoreSelectors.selectUploadFileProgress,
    );
  }

  error() {
    return this.store.select(AnchorEPIMSStoreSelectors.selectUploadFileError);
  }

  isInProgress() {
    return this.store.select(
      AnchorEPIMSStoreSelectors.selectUploadFileInProgress,
    );
  }
  isReady() {
    return this.store.select(AnchorEPIMSStoreSelectors.selectUploadFileReady);
  }
  hasFailed() {
    return this.store.select(AnchorEPIMSStoreSelectors.selectUploadFileFailed);
  }

  resetUpload() {
    this.store.dispatch(AnchorEPIMSActions.documentUploadReset());
  }

  cancelUpload() {
    this.store.dispatch(AnchorEPIMSActions.documentUploadCancel());
  }
}
